import PropTypes from 'prop-types';

export const FunnelStepPropTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
  funnelHasBeenReset: PropTypes.bool,
};
